import loadLightbox, { open } from "../Lightbox/src";
import { isOlympics, isParalympics } from "../../helpers";

interface lightboxProps {
  imageUrl: string;
  title: string;
  name: string;
  mainBody: string;
  linkedInUrl?: string;
}

interface Props {
  otherClasses?: string[];
}

export default ({ data = [], elClassName }: any) => {
  const elements: HTMLElement[] | null = Array.from(
    document.querySelectorAll(`.${elClassName}`)
  );

  let props: Props = {};
  let otherClasses = isOlympics
    ? "olympics"
    : isParalympics
    ? "paralympics"
    : "";

  if (otherClasses) {
    props.otherClasses = [otherClasses];
  }

  loadLightbox({
    elClassName: "lightbox-company",
    ...props
  });

  if (elements !== null) {
    elements.map((el: HTMLElement, key: number) => {
      if (!data[key].disable) {
        el.addEventListener(
          "click",
          open.bind(null, {
            func: () => updateLightBox(data[key]),
            className: "lightbox-company"
          })
        );
      }

      const name: HTMLElement | null = el.querySelector(
        ".company-structure__board-members-title"
      );

      if (name) {
        let HTML = `<span>${
          name.innerText.split(" ")[0]
        }</span>&nbsp;<span>${name.innerText.slice(
          name.innerText.indexOf(" ") + 1
        )}</span>`;

        name.innerHTML = HTML;
      }
    });
  }
};

const updateLightBox = ({
  name,
  title,
  imageUrl,
  mainBody,
  linkedInUrl
}: lightboxProps) => {
  const lb = document.querySelector(".lightbox-dialogue");

  if (lb !== null) {
    lb.innerHTML = `
      <div class="lightbox-content">
        <div class="lightbox-img">
          <img src="${imageUrl}">
          ${
            linkedInUrl
              ? '<a class="lightbox-linkedin" target="_blank" href="' +
                linkedInUrl +
                '">Connect</a>'
              : ""
          }
        </div>
        <div class="lightbox-description">
          <strong>${name}</strong>
          ${
            title
              ? '<span class="lightbox-description-title">' + title + "</span>"
              : ""
          }
          <span>${mainBody}</span>
        </div>
      </div>
    `;
  }
};
